<div data-testid="assign-user-dialog-container" class="assign-user-dialog p-4">
  <div class="space-y-4">
    <!-- Search fields -->
    <app-search-form
      data-testid="assign-user-dialog-search-form"
      [searchFormat]="searchFormConfig"
      (formSearch)="onSearch($event)"
      (formReset)="onSearchReset()"
    ></app-search-form>

    <!-- Search results -->
    <div class="search-results-section">
      <h4 class="text-sm font-semibold text-gray-700 mb-2">
        {{
          "configuration.business_unit.dialog.assign_user.search_results"
            | translate
        }}
      </h4>
      <div
        class="results-container border border-gray-200 rounded-lg bg-gray-50 p-2"
      >
        @if (searching()) {
          <div class="flex justify-center items-center py-8">
            <p-progressSpinner
              data-testid="assign-user-dialog-loading"
              strokeWidth="4"
              styleClass="w-10 h-10"
            ></p-progressSpinner>
          </div>
        } @else {
          @if (searchResults().length === 0) {
            <p class="text-sm text-gray-500 py-4 text-center">
              {{
                "configuration.business_unit.dialog.assign_user.no_results"
                  | translate
              }}
            </p>
          } @else {
            <div class="results-list overflow-y-auto">
              @for (user of searchResults(); track user.id ?? $index) {
                <button
                  [attr.data-testid]="
                    'assign-user-dialog-user-option-' + (user.id ?? $index)
                  "
                  type="button"
                  (click)="isAlreadyAssigned(user) ? null : selectUser(user)"
                  [disabled]="isAlreadyAssigned(user)"
                  (keydown.enter)="!isAlreadyAssigned(user) && selectUser(user)"
                  (keydown.space)="!isAlreadyAssigned(user) && selectUser(user)"
                  class="user-box rounded border p-3 mb-2 text-sm transition-colors relative w-full text-left"
                  [class.cursor-pointer]="!isAlreadyAssigned(user)"
                  [class.cursor-not-allowed]="isAlreadyAssigned(user)"
                  [class.opacity-60]="isAlreadyAssigned(user)"
                  [class.border-blue-500]="isSelected(user)"
                  [class.bg-blue-50]="isSelected(user)"
                  [class.border-gray-200]="
                    !isSelected(user) && !isAlreadyAssigned(user)
                  "
                  [class.bg-gray-100]="isAlreadyAssigned(user)"
                  [class.bg-white]="
                    !isSelected(user) && !isAlreadyAssigned(user)
                  "
                  [class.hover:border-gray-300]="
                    !isSelected(user) && !isAlreadyAssigned(user)
                  "
                >
                  @if (isAlreadyAssigned(user)) {
                    <div class="absolute top-2 right-2">
                      <p-tag
                        [attr.data-testid]="
                          'assign-user-dialog-already-assigned-tag-' +
                          (user.id ?? $index)
                        "
                        [value]="
                          'configuration.business_unit.dialog.assign_user.already_in_bu'
                            | translate
                        "
                        severity="info"
                        styleClass="text-xs"
                      ></p-tag>
                    </div>
                  }
                  <p class="mb-1">
                    <span class="font-medium text-gray-600">
                      {{
                        "configuration.business_unit.dialog.assign_user.first_name"
                          | translate
                      }}:
                    </span>
                    {{ user.firstName ?? "--" }}
                  </p>
                  <p class="mb-1">
                    <span class="font-medium text-gray-600">
                      {{
                        "configuration.business_unit.dialog.assign_user.last_name"
                          | translate
                      }}:
                    </span>
                    {{ user.lastName ?? "--" }}
                  </p>
                  <p class="mb-1">
                    <span class="font-medium text-gray-600">
                      {{
                        "configuration.business_unit.dialog.assign_user.username"
                          | translate
                      }}:
                    </span>
                    {{ user.username }}
                  </p>
                  <p class="mb-0">
                    <span class="font-medium text-gray-600">
                      {{
                        "configuration.business_unit.dialog.assign_user.email"
                          | translate
                      }}:
                    </span>
                    {{ user.email ?? "--" }}
                  </p>
                </button>
              }
            </div>
          }
        }
      </div>
    </div>

    <!-- Actions -->
    <div class="flex justify-end gap-3 pt-4 border-t border-gray-200">
      <app-button
        [testId]="'assign-user-dialog-cancel-btn'"
        [label]="'common.actions.cancel' | translate"
        type="secondary"
        [outlined]="true"
        [disabled]="assigning()"
        (emitOnClick)="onCancel()"
      ></app-button>
      <app-button
        [testId]="'assign-user-dialog-assign-btn'"
        [label]="
          'configuration.business_unit.table.action_buttons.assign_user'
            | translate
        "
        type="info"
        [disabled]="!selectedUser() || assigning()"
        [loading]="assigning()"
        (emitOnClick)="onAssign()"
      ></app-button>
    </div>
  </div>
</div>
